<div
  class="email-list-item flex cursor-pointer items-start gap-3 border-b border-gray-200 py-3 pl-2 pr-4 hover:bg-gray-5"
  [class]="email().Read ? 'bg-white' : 'bg-gray-5'">
  <!-- Checkbox -->
  <!--<div class="mt-1 flex items-center">
    <oiq-form-checkbox
      type="checkbox"
      label=""
      [value]="false"
      class="primary-contact-checkbox"></oiq-form-checkbox>
  </div>-->

  <!-- Avatar -->
  <!--<div class="flex-shrink-0">
    <div
      class="flex h-8 w-8 items-center justify-center rounded-full text-xs font-semibold text-white"
      [style.background-color]="avatarColor()">
      {{ avatarInitials() }}
    </div>
  </div>-->

  <!-- Email Content -->
  <div class="min-w-0 flex-1">
    <div class="flex flex-col gap-1">
      <!-- Header Row -->
      <div class="mb-1 flex w-full items-start justify-between gap-1">
        <div class="mb-2 flex min-w-0 items-center gap-2 overflow-hidden">
          @if (!isActiveSentLabel()) {
            <div
              class="flex h-8 w-8 items-center justify-center rounded-full text-xs font-semibold text-white"
              [style.background-color]="avatarColor()">
              {{ avatarInitials() }}
            </div>
          }
          <!-- Sender Name -->
          <div class="flex min-w-0 flex-col gap-1">
            <div class="truncate text-xs font-medium text-gray-900">
              @if (!isActiveSentLabel()) {
                {{ senderName() }}
                @if (email()?.DraftID) {
                  <span class="text-primary">[Draft]</span>
                }
              } @else {
                {{ recipients() }}
              }
            </div>
            <!-- Attachments and Link Row -->
            <div class="flex items-center gap-4">
              <!-- @if ((email()?.HasAttachments || []).length > 0) { -->
              <!-- Attachments -->
              <!-- <div class="flex items-center gap-1 text-xs text-[#8A8F9B]">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.77822 10.0526C9.78118 10.0498 9.78412 10.0471 9.78702 10.0443L12.4976 7.49503C12.8154 7.19612 13.0675 6.84127 13.2395 6.45074C13.4115 6.0602 13.5 5.64163 13.5 5.21891C13.5 4.7962 13.4115 4.37762 13.2395 3.98709C13.0675 3.59655 12.8154 3.2417 12.4976 2.9428C12.1797 2.64389 11.8024 2.40679 11.3872 2.24503C10.972 2.08326 10.5269 2 10.0774 2C9.16971 2 8.29917 2.33913 7.65732 2.9428L5.3428 5.11959L5.334 5.12787L3.86697 6.50678C2.99171 7.32996 2.5 8.44642 2.5 9.61057C2.5 10.7747 2.99171 11.8912 3.86697 12.7144C4.74223 13.5375 5.92933 14 7.16713 14C8.40493 14 9.59204 13.5375 10.4673 12.7144L13.2544 10.0939C13.3174 10.0366 13.3676 9.96813 13.4022 9.89238C13.4368 9.81663 13.4549 9.73516 13.4556 9.65274C13.4564 9.57031 13.4396 9.48858 13.4064 9.41231C13.3732 9.33603 13.3241 9.26675 13.2621 9.20849C13.2001 9.15023 13.1264 9.10417 13.0453 9.073C12.9641 9.04182 12.8772 9.02615 12.7896 9.02691C12.7019 9.02766 12.6153 9.04482 12.5348 9.07739C12.4543 9.10996 12.3815 9.15728 12.3207 9.2166L9.53445 11.837C8.90671 12.4274 8.05532 12.7591 7.16757 12.7591C6.27982 12.7591 5.42843 12.4274 4.8007 11.837C4.17296 11.2466 3.82031 10.4459 3.82031 9.61099C3.82031 8.77606 4.17296 7.97533 4.8007 7.38495L5.87083 6.37849L5.88051 6.37021L8.59104 3.82014C8.9884 3.46371 9.5182 3.26756 10.0673 3.27359C10.6163 3.27963 11.1411 3.48737 11.5295 3.85243C11.9179 4.21749 12.1391 4.71093 12.1458 5.22732C12.1526 5.74372 11.9443 6.24211 11.5656 6.61603L10.5711 7.55131L10.5606 7.56124L7.92485 10.0393C7.8463 10.1186 7.75157 10.1822 7.64632 10.2263C7.54106 10.2704 7.42744 10.2941 7.31223 10.296C7.19702 10.2979 7.08259 10.278 6.97574 10.2374C6.8689 10.1968 6.77185 10.1364 6.69037 10.0598C6.60889 9.98317 6.54466 9.89189 6.5015 9.7914C6.45835 9.69092 6.43716 9.58329 6.43919 9.47493C6.44122 9.36658 6.46644 9.25972 6.51334 9.16073C6.56023 9.06174 6.62785 8.97265 6.71215 8.89877L9.347 6.41905C9.46359 6.30137 9.52706 6.14573 9.52404 5.98491C9.52103 5.82409 9.45176 5.67065 9.33083 5.55692C9.2099 5.44318 9.04675 5.37804 8.87576 5.3752C8.70476 5.37236 8.53927 5.43206 8.41415 5.54171L5.77843 8.01978C5.37677 8.40525 5.15308 8.92422 5.15598 9.46393C5.15888 10.0036 5.38812 10.5205 5.7939 10.9021C6.19968 11.2837 6.74921 11.4993 7.32306 11.5021C7.89691 11.5048 8.44872 11.2944 8.85858 10.9166L9.77822 10.0526Z"
                      fill="#8A8F9B" />
                  </svg>

                  <span>{{ (email()?.Attachments || []).length }} attachment(s)</span>
                </div> -->
              <!-- } -->

              <!-- Link to Client -->
              @if (linked()) {
                <div class="flex items-center gap-1 text-xs font-bold text-[#8A8F9B]">
                  <span>Client:</span>
                  <span class="text-black underline">{{ linked().clientName }}</span>
                </div>

                @if (linked().applicationId) {
                  <div class="flex items-center gap-1 text-xs font-bold text-[#8A8F9B]">
                    <span>Application:</span>
                    <span class="text-black underline">{{ linked().applicationId }}</span>
                  </div>
                }
              } @else {
                @if (!email()?.DraftID) {
                  <div
                    class="flex items-center gap-1 text-xs text-primary"
                    (click)="onSearchClients()">
                    <svg
                      width="14"
                      height="12"
                      viewBox="0 0 14 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3.93286 9.5C3.46619 9.88889 2.98019 10.0667 2.47486 10.0333C1.96953 10 1.52775 9.82778 1.14953 9.51667C0.771305 9.20555 0.513083 8.79733 0.37486 8.292C0.236638 7.78667 0.328194 7.26711 0.649527 6.73333L1.89953 4.66667C1.62175 4.42222 1.40242 4.12778 1.24153 3.78333C1.08064 3.43889 0.999972 3.06667 0.999527 2.66667C0.999527 1.93333 1.26064 1.30556 1.78286 0.783333C2.30508 0.261111 2.93286 0 3.66619 0C4.39953 0 5.0273 0.261111 5.54953 0.783333C6.07175 1.30556 6.33286 1.93333 6.33286 2.66667C6.33286 3.4 6.07175 4.02778 5.54953 4.55C5.0273 5.07222 4.39953 5.33333 3.66619 5.33333C3.56619 5.33333 3.46619 5.32778 3.36619 5.31667C3.26619 5.30556 3.17175 5.28889 3.08286 5.26667L1.79953 7.43333C1.6773 7.63333 1.63842 7.83067 1.68286 8.02533C1.72731 8.22 1.82175 8.37822 1.96619 8.5C2.11064 8.62178 2.28286 8.69133 2.48286 8.70867C2.68286 8.726 2.8773 8.65644 3.06619 8.5L10.0662 2.48333C10.5329 2.09444 11.0217 1.91933 11.5329 1.958C12.044 1.99667 12.4884 2.17178 12.8662 2.48333C13.244 2.79489 13.4995 3.20333 13.6329 3.70867C13.7662 4.214 13.6717 4.73333 13.3495 5.26667L12.0995 7.33333C12.3773 7.57778 12.5969 7.87222 12.7582 8.21667C12.9195 8.56111 13 8.93333 12.9995 9.33333C12.9995 10.0667 12.7384 10.6944 12.2162 11.2167C11.694 11.7389 11.0662 12 10.3329 12C9.59953 12 8.97175 11.7389 8.44953 11.2167C7.92731 10.6944 7.66619 10.0667 7.66619 9.33333C7.66619 8.6 7.92731 7.97222 8.44953 7.45C8.97175 6.92778 9.59953 6.66667 10.3329 6.66667C10.4329 6.66667 10.5302 6.67222 10.6249 6.68333C10.7195 6.69444 10.8111 6.71111 10.8995 6.73333L12.1995 4.56667C12.3217 4.36667 12.3606 4.16933 12.3162 3.97467C12.2718 3.78 12.1773 3.62178 12.0329 3.5C11.8884 3.37822 11.7162 3.30889 11.5162 3.292C11.3162 3.27511 11.1217 3.34444 10.9329 3.5L3.93286 9.5ZM3.66619 4C4.03286 4 4.34686 3.86956 4.60819 3.60867C4.86953 3.34778 4.99997 3.03378 4.99953 2.66667C4.99908 2.29956 4.86864 1.98578 4.60819 1.72533C4.34775 1.46489 4.03375 1.33422 3.66619 1.33333C3.29864 1.33244 2.98486 1.46311 2.72486 1.72533C2.46486 1.98756 2.33419 2.30133 2.33286 2.66667C2.33153 3.032 2.46219 3.346 2.72486 3.60867C2.98753 3.87133 3.3013 4.00178 3.66619 4ZM10.3329 10.6667C10.6995 10.6667 11.0135 10.5362 11.2749 10.2753C11.5362 10.0144 11.6666 9.70045 11.6662 9.33333C11.6657 8.96622 11.5353 8.65244 11.2749 8.392C11.0144 8.13156 10.7004 8.00089 10.3329 8C9.96531 7.99911 9.65153 8.12978 9.39153 8.392C9.13153 8.65422 9.00086 8.968 8.99953 9.33333C8.99819 9.69867 9.12886 10.0127 9.39153 10.2753C9.65419 10.538 9.96797 10.6684 10.3329 10.6667Z"
                        fill="#FF5127" />
                    </svg>

                    <span>Link to Client</span>
                  </div>
                }
              }
            </div>
          </div>
        </div>

        <!-- Timestamp and Status -->
        <div class="relative flex flex-shrink-0 items-center gap-2">
          @if (hasErrors()) {
            <div
              class="flex items-center gap-1 rounded-full border border-red-3/50 bg-red-4 p-0.5 text-[#c50000]"
              title="This email couldn't be ingested.">
              <span class="material-symbols-outlined flex-shrink-0 text-xxs leading-none">
                warning
              </span>
            </div>
          }
          @if (!email().Read) {
            <div class="absolute -right-3 -top-1.5 h-1.5 w-1.5 rounded-full bg-orange-1"></div>
          }
        </div>
      </div>
    </div>

    <!-- Subject -->
    <div class="mb-1 text-xs font-medium text-gray-900">{{ email().Subject }}</div>

    <!-- Preview Text -->
    <div class="flex items-center justify-between gap-4">
      <div class="truncate text-xs text-[#8A8F9B]">
        {{ email().Body | slice: 0 : 100 }}
      </div>
      <p class="min-w-max text-xs text-[#C2C8D1]">{{ formattedDate() }}</p>
    </div>
  </div>
</div>
